
import { EmployerWeekRuleInterval, EmployerDayRuleInterval } from '../backend/src/services/resources/employer-rules/employer-rule.model'
const employerRulesLocales: {
  inputs: {
    week: {
      [KEY in EmployerWeekRuleInterval['input']]: string
    }
    day: {
      [KEY in EmployerDayRuleInterval['input']]: string
    }
  }
} = {
  inputs: {
    week: {
        'durations.worked.night': 'Heures travaillées la nuit',
        'durations.worked.day': 'Heures travaillées la journée',
        'durations.worked.total': 'Heures totale travaillées (Jour & Nuit)',
        'durations.worked.theoretical': 'Heures théoriques à travailler (pause déduite)',
        'durations.contract.total': 'Heures théoriques contractuelles',
        'durations.contract.remainingAfterBenefit': 'Heures contractuelles restantes après prestations (résumé)',
        'durations.benefit': 'Heures travail Non Effetif',
        'durations.total.total': 'Heures totales (avec événement prestation & règles employeur)',
    },
    day: {
      'durations.worked.night': 'Heures travaillées la nuit',
      'durations.worked.day': 'Heures travaillées la journée',
      'durations.worked.total': 'Heures totale travaillées (Jour & Nuit)',
      'durations.worked.theoretical': 'Heures théoriques à travailler (pause déduite)',
      'durations.contract.total': 'Heures théoriques contractuelles',
      'durations.contract.remainingAfterBenefit': 'Heures contractuelles restantes après prestations (résumé)',
      'durations.benefit': 'Heures travail Non Effetif',
      'durations.total.total': 'Heures totales (avec événement prestation & règles employeur)',
    }
  }
}

export default employerRulesLocales